import {
    ResponsiveContainer,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    Radar,
    Legend,
    ComposedChart,
    CartesianGrid, XAxis, Bar, YAxis, ReferenceLine, Line, Tooltip as ReChartsTooltip
} from 'recharts';
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import Widget from "../../prefabricated/Widget";
import {
    bbErrorSection,
    bbFindEntityWithinPortfolioOrSelf,
    bbFormattedDateString, bbIsObject,
    bbTranslateBreachRiskScoreToCategory,
    bbTranslateBreachRiskScoreToColor,
} from "../../../util/bbHelpers";
import React from "react";
import InfoSharpIcon from "@material-ui/icons/InfoSharp";
import {useSelector} from "react-redux";
import Skeleton from "react-loading-skeleton";
import {Badge} from "reactstrap";
import BRFidelityBadge from "../BRPortfolio/BRFidelityBadge";

const testData = [
    {
        name: "Example Fact",
        thisEntityValue: [7,7],
        averageValue: 7
    },
    // {
    //     name: "Example Fact 2",
    //     thisEntityValue: 80,
    //     averageValue: 120
    // },

];

function CustomTooltip({ payload, label, active }) {
    // console.log("RiskComparisonFactBar tip payload is", payload, "label", label, "active", active)
    if (active && payload) {

        const name = payload[0].payload.name;
        const entityValue = payload[0].payload.thisEntityValue;
        const highestValue = payload[0].payload.highestValue;
        const lowestValue = payload[0].payload.lowestValue;
        const averageValue = payload[0].payload.averageValue;

        const isCaseWhereAllAreEqual = highestValue === lowestValue &&  lowestValue === averageValue;

        const valueUnit = payload[0].payload.valueUnit;
        //TODO: Foster this logic is so screwed up. Forget about it then rewrite it.
        const entityDisplayText = isCaseWhereAllAreEqual && Array.isArray(entityValue)
            ? <>{lowestValue} {valueUnit && valueUnit} <em>and counting</em>.</>
            : Array.isArray(entityValue) && entityValue.length > 1 ? `${lowestValue} ${valueUnit && valueUnit} - ${highestValue} ${valueUnit && valueUnit}` : parseFloat(entityValue).toFixed(1);
        const subtitleText = isCaseWhereAllAreEqual && Array.isArray(entityValue)
            ? null
            : <small><em>{`${entityValue > averageValue ? "Above the Average" : entityValue === averageValue ? "At Average" : Array.isArray(entityValue) ? `Average` : "Below the Average"} of ${averageValue}`}</em></small>

        const forcedMaxValue = payload[0].payload.forcedMaxValue;

        // console.log("RiskComparisonFactBar tip forcedMaxValue", forcedMaxValue );

        return (
            // <div style={{zIndex: 100000}}>
                <Widget styleName={`p-1 px-2`}>
                    <h2 className="label ">{name} </h2>
                    <h3 className={"m-0 p-0"}>{entityDisplayText}<small className={"text-light-gray"}>{forcedMaxValue && `/${forcedMaxValue}`}</small> {subtitleText}</h3>
                    {/*<hr/>*/}
                    <div className={"m-0 p-0"}> <small>{payload[0].payload.toolTipDescription}</small></div>
                </Widget>
            // </div>
        );
    }

    return null;
}

const RenderChart = (
    {
        dataBranch = null,
        avgVarName = null,
        avgValue = null,
        maxValue = null,
        minValue = null,
        thisEntityVarName = null,
        factName = "Fact Name",
        averageDisplayName = null,
        small = false,
        forcedMaxValue = null,
        // boxplot = false,
        colorThresholdDict = null,
        colorThresholdValue = null,
        toolTipTitle = null,
        toolTipDescription= null,
        valueUnit = null,
        hideChart = false,
        useThisEntityInstead = false,
        showLineLabels = false,

    }
    ) => {

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView, loadingPortfolios, loadingPortfoliosError} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const useGivenEntityInstead = useThisEntityInstead && bbIsObject(useThisEntityInstead) && useThisEntityInstead.last_cycle ? useThisEntityInstead : null;
    const entityToUse = useGivenEntityInstead ? useGivenEntityInstead : myEntity;

    const dataBranchResults = entityToUse
    && entityToUse.last_cycle
        ? dataBranch
        && entityToUse.last_cycle[`${dataBranch}`]
            ? entityToUse.last_cycle[`${dataBranch}`]
            : entityToUse.last_cycle
        : null;

    const portfolioAverages = portfolios && customerIdToUse && portfolios[customerIdToUse] &&  portfolios[customerIdToUse].averages;

    const thisEntityValue = dataBranchResults && dataBranchResults[thisEntityVarName];
    const averageValue = avgValue ? avgValue : portfolioAverages && portfolioAverages[avgVarName];







    // const chartData = dataBranchResults ? [] : null;
    //
    // const subdomains = dataBranchResults && dataBranchResults.subdomains
    //     ? {
    //         dim: 'Subdomains',
    //         value: dataBranchResults.subdomains,
    //         avg: 53.9
    //     }
    //     : {}

    const isAvgTheHighestValue = thisEntityValue && averageValue
        ? averageValue > thisEntityValue
        : null

    const isEntityValueWithin15OfAverage = thisEntityValue && averageValue
        ? ((thisEntityValue * 1.01) < averageValue) || ((averageValue * 0.95) < thisEntityValue)
        : undefined;

    // console.log("figuring out color of bar. ", "thisEntityValue", thisEntityValue, "averageValue", averageValue, "(thisEntityValue * 1.15)", (thisEntityValue * 1.15), "(thisEntityValue * 0.85)", (thisEntityValue * 0.85), "((thisEntityValue * 1.15) < averageValue) || ((thisEntityValue * 0.85) > averageValue)", ((thisEntityValue * 1.15) < averageValue) || ((thisEntityValue * 0.85) < averageValue))

    const highestValue = maxValue
    ? maxValue
    : thisEntityValue && averageValue
        ? thisEntityValue > averageValue ? thisEntityValue : averageValue
            : null

    const lowestValue = minValue
        ? minValue
        : thisEntityValue && averageValue && highestValue
            ? thisEntityValue === highestValue ? averageValue : thisEntityValue
            : null

    const isCaseWhereAllAreEqual = highestValue === lowestValue &&  lowestValue === averageValue;

    const chartData = (minValue !== null && maxValue !== null && avgValue !== null) || (portfolioAverages && averageValue && thisEntityValue)
        ? [{
            name: factName,
            thisEntityValue: thisEntityValue ? thisEntityValue : [isCaseWhereAllAreEqual ? 0 : minValue, maxValue],
            averageValue: averageValue,
            lowestValue: lowestValue,
            highestValue: highestValue,
            averageDisplayName: averageDisplayName,
            toolTipTitle: toolTipTitle,
            toolTipDescription: toolTipDescription,
            forcedMaxValue: forcedMaxValue,
            valueUnit: valueUnit
        }]
        : null

    const hideChartBecauseNoData = hideChart
        || !chartData
        || (maxValue !== null & minValue !== null && (maxValue < 1 || minValue < 1));

    const colorForBar = () => {
        // if(isEntityValueWithin15OfAverage) {
        //     return "#F2E205"
        // } else if (isAvgTheHighestValue) {
        //     return "#00863B"
        // } else {
        //     return "#D93D04"
        // }
        if (colorThresholdDict && colorThresholdValue) {
            //look at the dictionary to see if it gives enough info to create thresholds
            console.log("checking custom color for fact bar", "colorThresholdDict", colorThresholdDict, "colorThresholdValue", colorThresholdValue)
            if(colorThresholdDict.low && colorThresholdDict.lowest && colorThresholdDict.medium && colorThresholdDict.high){
                //check each threshold to assign one of the 5 risk colors
                if(colorThresholdValue > colorThresholdDict.high) {
                    //above the high threshold, give highest risk color
                    return "#D93D04"
                } else if (colorThresholdValue > colorThresholdDict.medium) {
                    return "#F28705"
                } else if (colorThresholdValue > colorThresholdDict.low) {
                    return "#F2E205"
                } else if (colorThresholdValue > colorThresholdDict.lowest) {
                    return "#5FBA15"
                } else if (colorThresholdValue <= colorThresholdDict.lowest) {
                    return "#00863B"
                } else {
                    //something wasn't right
                    return "gray"
                }

            } else {
                return "gray"
            }
        } else {
            if (isAvgTheHighestValue) {
                return "#00863B"
            } else if (lowestValue === highestValue) {
                return "#F2E205"
            } else {
                return "#D93D04"
            }
        }
    }

    // console.log("New bar fact chart widget. Looking for dataBranch",
    //     dataBranch, "found this:",
    //     dataBranchResults, "entityToUse", entityToUse, "entityToUse.last_cycle", entityToUse && entityToUse.last_cycle,
    //     "portfolios", portfolios,
    //     "portfolioAverages", portfolioAverages,
    //     "thisEntityValue", thisEntityValue,
    //     "avgVarName", avgVarName,
    //     "averageValue", Math.round(averageValue * 10) / 10,
    //     "avgValue", avgValue,
    //     "maxValue", maxValue,
    //     "minValue", minValue,
    //     "chart data is", chartData,
    //     "dataBranch", dataBranch,
    //     "avgVarName", avgVarName,
    //     "avgValue", avgValue,
    //     "maxValue", maxValue,
    //     "minValue", minValue,
    //     "thisEntityVarName", thisEntityVarName,
    //     "factName", factName,
    //     "averageDisplayName", averageDisplayName,
    //     "small", small,
    //     "forcedMaxValue", forcedMaxValue,
    //     // boxplot = false,
    //     "colorThresholdDict", colorThresholdDict,
    //     "colorThresholdValue", colorThresholdValue,
    //     "toolTipTitle", toolTipTitle,
    //     "toolTipDescription", toolTipDescription,
    //     "valueUnit", valueUnit,
    //     "hideChartBecauseNoData", hideChartBecauseNoData,
    //     "hideChart", hideChart,
    //     "isCaseWhereAllAreEqual", isCaseWhereAllAreEqual
    //
    //     );


    // return true;

    const substance = <>
                {/*<Tooltip disableFocusListener*/}
                {/*         title={"How your BreachRisk™ Score - your risk of a breach - has changed over time. Lower scores are better."}>*/}
                {/*    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}*/}
                {/*                   className={`text-muted`}/>*/}
                {/*</Tooltip>*/}
                {/*<div className="row">*/}
                {/*    <div className={"col-12"}>*/}


                {/*    </div>*/}
                {/*</div>*/}
                <div className="row" style={{height: small ? 70 : 200}}>
                <div className={"col-12"}>
                    {!portfolios || loadingPortfolios[customerIdToUse] ?
                        <Skeleton count={small ? 3 : 7}/>
                        : !entityToUse || loadingPortfoliosError[customerIdToUse] ?
                            <div className={"text-center"}>
                                {bbErrorSection("80px")}
                            </div>
                            : hideChartBecauseNoData
                                ? <Tooltip title={toolTipDescription}>
                                    <p style={{marginBottom: "2px", marginTop:"25px"}}>
                                        <em>No data</em>
                                    </p>
                                    </Tooltip>
                                :  <ResponsiveContainer width="100%" height="100%" >
                                <ComposedChart
                                    layout="vertical"
                                    width={300}
                                    height={70}
                                    data={chartData}
                                    margin={{
                                        top: 20,
                                        right: 3,
                                        bottom: 3,
                                        left: 3,
                                    }}
                                >

                                    <CartesianGrid stroke="#f5f5f5" />
                                    {!hideChartBecauseNoData &&
                                        <XAxis
                                            type="number"
                                            domain={[dataMin => (0 ), dataMax => (forcedMaxValue ? forcedMaxValue : highestValue * 1.2)]}
                                            axisLine={false}
                                            ticks={ [0, minValue ? minValue : lowestValue, maxValue ? avgValue : isAvgTheHighestValue ? highestValue : undefined, maxValue ? maxValue : forcedMaxValue ? forcedMaxValue : undefined]}
                                        />                                    }

                                    <YAxis dataKey="name" type="category" scale="band" hide />
                                    <ReChartsTooltip content={<CustomTooltip/>} wrapperStyle={{zIndex: 100, marginTop:-160}}/>
                                    {!hideChartBecauseNoData &&
                                        <Bar name = "This Company" dataKey="thisEntityValue" barSize={20} fill={colorForBar()} />
                                    }
                                    {/*{!hideChartBecauseNoData &&*/}
                                    {/*    <Bar name = {`${averageDisplayName ? averageDisplayName : "Avg"}`} dataKey="averageValue" barSize={0} fill="#343a40" />*/}
                                    {/*}*/}
                                    {!hideChartBecauseNoData &&
                                        <ReferenceLine x={averageValue} stroke="#343a40" strokeWidth={5} label={{ position: 'right',  value: `${averageDisplayName ? averageDisplayName : "Avg"}`, fill: '#343a40', fontSize: 16, fontWeight: "bold" }} />
                                    }


                                </ComposedChart>
                            </ResponsiveContainer>
                    }
                </div>
            </div>
        </>

    return <> {small
        ? <div>
            <h3 style={{marginBottom: "-25px", marginTop:"15px"}}>{!portfolios || loadingPortfolios[customerIdToUse] ? <Skeleton/> : factName}</h3>
            {substance}
        </div>
        :   <Widget styleName={`p-2 animated fadeIn animation-duration-5`}>
                <Tooltip disableFocusListener
                         title={"Attack Surface is important context that attackers consider when surveying, planning, and conducting attacks. Here's how this entity compares to global averages."}>
                    <InfoSharpIcon style={{fontSize: "20px", marginLeft: "auto", marginTop: 0, zIndex: 5}}
                                   className={`text-muted`}/>
                </Tooltip>
                <div className="row"  id={""}>
                    <div className={"col-12"}>
                        <h1 className={"text-center"}>Attack Surface Comparison</h1>
                        {/*<h2 className={"text-center"}>Comparative Exposure</h2>*/}


                    </div>
                </div>
                {substance}
            </Widget>
        }


    </>
};

export default RenderChart;